/**
 * Simulates database pagination for a given array of data
 * @see https://www.typescriptlang.org/docs/handbook/2/generics.html for Generics
 * @param data Data to be paginated
 * @param page The page (index) to start at
 * @param limit How many items to return
 * @returns Subset of the provided data
 */
export function paginate<T>(data: T[], page: number, limit: number): T[] {
    return data.slice((page - 1) * limit, limit * page);
}
